import { combineReducers } from 'redux';
import { bazaarVoiceRatingsReducer } from '@gcc/pip-components/dist/BazaarVoice';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import configurator from './configurator';
import productReducer from './products';
import draftingToolReducer from './draftingTool';
import countertopsReducer from './countertops';
import zipcodeReducer from './zipcode';
import storeReducer from './store';
import designReducer from './design';
import persistedShapeInfo from './persistedShape';
import config from './config';
import plaConfigurationReducer from './plaConfiguration';
import sinkQuantityWarningReducer from './sinkQuantityWarning';
import { RESET_STATE_TO_INITIAL } from '../actions/plaConfigurations';

const persistedShapeConfig = {
  key: 'persistedShapeInfo',
  storage,
};

const customSurfaceReducer = combineReducers({
  config,
  configurator,
  products: productReducer,
  countertops: countertopsReducer,
  draftingTool: draftingToolReducer,
  persistedShapeInfo: persistReducer(persistedShapeConfig, persistedShapeInfo),
  zipcode: zipcodeReducer,
  store: storeReducer,
  design: designReducer,
  bazaarVoiceRatings: bazaarVoiceRatingsReducer,
  plaConfiguration: plaConfigurationReducer,
  sinkQuantityWarning: sinkQuantityWarningReducer
});

const rootReducer = (state, action) => {
  if (action.type === RESET_STATE_TO_INITIAL) {
    return customSurfaceReducer(undefined, action);
  }
  return customSurfaceReducer(state, action);
};
export default rootReducer;
